// src/components/AboutContent.js
import React from 'react';
import './AboutContent.css'; // Assuming you have a CSS file for styling


const AboutContent = () => {
  return (
    <div className="c">
      <div className="about-overview-container">
        <div className="about-overview-info">
          <h2 className="about-overview-header">About Our Practice</h2>
          <div className="about-custom-line"></div>
          <p className="about-text">
           We are a dental practice devoted to restoring and enhancing the natural beauty of your smile using conservative, state-of-the-art procedures that will result in beautiful, long lasting smiles!
          </p>
          <p className="about-text">
            As a practice, we believe in the importance of preventive care and education for optimal dental health. That’s why we focus on thorough exams – checking the overall health of your teeth and gums, performing oral cancer exams, and taking X-rays when necessary.  We also know that routine cleanings, flossing, sealants, and fluoride are all helpful in preventing dental disease.  Not only are we focused on the beauty of your smile, we’re also concerned about your health.  A review of your medical history can help us stay informed of your overall health, any new medications, and any illnesses that may impact your dental health.
          </p>
        </div>

        <div className="about-us-image-container">
          <img 
            src="/images/about-overview.avif" 
            alt="Dental Practice" 
            className="about-us-1"
          />
        </div>
      </div>

      <div className="uncompromising-safety-container">
        <div className="uncompromising-safety-info">
          <h2 className="uncompromising-safety-header">Uncompromised Safety</h2>
          <div className="uncompromising-custom-line"></div>
          <p className="uncompromising-text">
            Infection control in our office is also very important to us.  To protect our patients and ourselves, we strictly maintain sterilization and cross contamination processes using standards recommended by the American Dental Association (ADA), the Occupational Safety and Health Administration (OSHA), and the Center for Disease Control (CDC).
          </p>
        </div>
      </div>

      <div className="meet-team-overview-container">
        <div className="meet-team-overview-info">
          <h2 className="meet-team-header">Meet Our Team</h2>
          <div className="meet-team-custom-line"></div>
          <p className="meet-team-text">
            As your dental health professionals, we want you to be confident knowing that we are a team of highly trained and skilled clinicians.  We pride ourselves in providing the care you need to keep your smile healthy.  To give you the best possible service and results, we are committed to continual education and learning.  We attend dental lectures, meetings, and dental conventions to stay informed of new techniques, the latest products, and the newest equipment that a modern dental office can utilize to provide state-of-the-art dental care.  Also, being members of various professional dental associations helps us to stay abreast of the changes and recommendations for our profession.
          </p>
        </div>
      </div>

      <div className="meet-team-container">
        <div className='member-card'>
          <div className="member-image-overview">
            <div className="member-image-container">
              <img 
                src='/images/deepa-alexander.jpg'
                alt="Team Member" 
                className="member-image"
              />
            </div>
            <p className="member-title">Dr. Deepa Alexander</p>
          </div>
          <div className="member-info">
            <p className="member-text">
              <strong> Dr. Alexander </strong> has a Bachelor of Dental Surgery (B.D.S) from Mangalore University, India (1995). After moving to the United States, she joined the Advanced Standing D.D.S Program at New York University, receiving her Doctor of Dental Surgery (D.D.S) in 2000. 
                She has over 25 years of experience in the field, and her attention to detail and genuine care for patient well-being makes her a trusted and valuable dentist. She's known for her friendly demeanor and calming presence, helping her patients to feel at ease during their visits. Dr. Alexander is constantly updating her skills and staying abreast on the latest developments in dentistry – she has spent hundreds of hours participating in study clubs, attending seminars and taking several continuing education courses annually.
                In her free time, she enjoys traveling the world with her husband and daughter, exploring new cultures. She also loves gardening, cooking, and spending quality time with her family and friends.
            </p>
          </div>
        </div>

        <div className='member-card'>
          <div className="member-image-overview">
            <div className="member-image-container">
              <img 
                src='/images/james-mcgee.jpg'
                alt="Team Member" 
                className="member-image"
              />
            </div>
            <p className="member-title">Dr. James McGee</p>
          </div>
          <div className="member-info">
            <p className="member-text">
              {/* remove family names */}
              <strong>Dr. McGee</strong> Dr. McGee was born and raised in Mississippi. After graduating from the University of Southern Mississippi in 1994 with a B.S. in Biology, he went to dental school at the University of Mississippi School of Dentistry in Jackson, MS. In 1997, he graduated from dental school with a D.M.D. degree and moved to Atlanta, where he met his wife. They now have a beautiful young daughter. Once in Atlanta, Dr. McGee immediately began practicing dentistry in a large group practice. In 1998, Dr. McGee opened his own practice in Stone Mountain, GA where he has been practicing ever since. He has dedicated his professional career to providing his patients with the best that dentistry has to offer. 
              Dr. McGee has the great ability to put his patients at ease and his patients usually leave with a laugh and a smile on their faces. He's at this location every Monday. 
            </p>
            <p className="member-text">
              Dr. McGee donates his services to the Ben Massell Dental Clinic in downtown Atlanta. He has also been involved with the Dominican Republic Dental Mission Project and Volunteers in Medical Missions where he provided dental services to the people of the Dominican Republic and Honduras.
            </p>

          </div>
        </div>

        <div className='member-card'>
          <div className="member-image-overview">
            <div className="member-image-container">
              <img 
                src='/images/erika.jpg'
                alt="Team Member" 
                className="member-image"
              />
            </div>
            <p className="member-title">Erika</p>
          </div>
          <div className="member-info">
            {/* Certified Dental Assistant Title */}
            <p className="member-text">
              <strong>Erika</strong> is a certified dental assistant, trained at Gwinnett Technical College and Atlanta Dental Assistant School, with over 5 years of experience in the field.
              She is dedicated and compassionate, always striving in providing high-quality patient care and clinical support. She is skilled in chairside assistance, dental radiography, sterilization protocols, and administrative coordination. Outside the office, Erika enjoys serving in church, volunteering at local charities, and spending quality time with her son. She is continuing her education in dental health and patient care as well.
            </p>
          </div>
        </div>

         {/*
        <div className='member-card'>
          <div className="member-image-overview">
            <div className="member-image-container">
              <img 
                src='/images/julie.jpg'
                alt="Team Member" 
                className="member-image"
              />
            </div>
            <p className="member-title">Julie</p>
          </div>
         
          <div className="member-info"> 
            <p className="member-text">
              <strong>Julie</strong> is a ceritifed dental assistant, graduating from the Dental Careers Institute in Marietta, GA in 2005. She has 20 years of dental-assisting experience, specializing in periodontics and oral surgery. Julie cares about her patients and always tries to keep them comfortable.  She loves attending country music concerts, vacationing at the beach, and spending time with her two sons.
            </p>
          </div>
        </div>
        */}
      </div>

  
    </div>
  );
};

export default AboutContent;

/*
  <img 
  src="/images/room-center.jpg" 
  alt="Background" 
  className="background-image"
  ></img>


  <!--
        <div className='member-card'>
          <div className="member-image-overview">
            <div className="member-image-container">
              <img 
                src='/images/john-birch.jpg'
                alt="Team Member" 
                className="member-image"
              />
            </div>
            <p className="member-title">Dr. John Birch</p>
          </div>
          <div className="member-info">
            <p className="member-text">
              <strong>Dr. Birch</strong> was raised in Atlanta and takes pride in acknowledging that he graduated from Emory University with a doctorate in Dentistry in 1985. Dr. Birch has practiced in Florida and Georgia for over 35 years with special emphasis on continuing education in oral surgery, endodontics, and prosthetics. He strives to excel in quality dentistry, catering to all his patients needs in a warm compassionate manner. 
              When Dr. Birch isn’t in the office, he and his family of four love to go exploring in search of the perfect camping and hiking spots. He is an avid skier, and on sunny days, he is often found riding on his motorcycle.
              While Dr. Birch practices in Cumming, GA, he is at this location every Tuesday.
            </p>
          </div>
        </div>
        -->
*/